module.exports = __webpack_public_path__ + "static/media/traffic-roadworks.31a42dd7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traffic-roadworks.svg
// module id = 909
// module chunks = 0